import { render } from "./ListeCategorieFaq.vue?vue&type=template&id=0523cc84&ts=true"
import script from "./ListeCategorieFaq.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieFaq.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__